import React, { useState, useEffect } from "react";
import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  ConfigProvider,
  Space,
  Modal,
  Form,
  Input,
  Select,
  Upload,
  Rate,
  Radio,
  Checkbox,
  Flex,
  Progress,
  message,
} from "antd";
import { createStyles } from "antd-style";
import axios from "axios";
import localhost from "../../constants/localhost";

const useStyle = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    &.${prefixCls}-btn-primary:not([disabled]):not(
        .${prefixCls}-btn-dangerous
      ) {
      > span {
        position: relative;
      }

      &::before {
        content: "";
        background: linear-gradient(135deg, #6253e1, #04befe);
        position: absolute;
        inset: -1px;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `,
}));

const Center = ({ getData, id, mode }) => {
  const { styles } = useStyle();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const getDetail = () => {
    axios
      .get(`${localhost}/manage/material/getDetail?id=${id}`)
      .then((res) => {
        form.setFieldsValue(res?.data || {});
      })
      .catch((error) => {
        message.error("网络异常，请重试！");
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!visible || !id) {
      return;
    }
    getDetail();
  }, [id, visible]);

  const onAdd = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        axios
          .post(`${localhost}/manage/material/save`, values)
          .then((res) => {
            message.success(`${mode === "edit" ? "编辑" : "新增"}内容成功！`);
            setLoading(false);
            setVisible(false);
            getData();
          })
          .catch((error) => {
            message.error("网络异常，请重试！");
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <>
      <ConfigProvider
        button={{
          className: styles.linearGradientButton,
        }}
      >
        <Space>
          {id ? (
            <a onClick={() => setVisible(true)}>
              {mode === "detail" ? "详情" : "编辑"}
            </a>
          ) : (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setVisible(true)}
            >
              新增内容
            </Button>
          )}
        </Space>
      </ConfigProvider>
      <Modal
        width={800}
        title={id ? (mode === "detail" ? "查看详情" : "编辑内容") : "新增内容"}
        closeIcon={false}
        open={visible}
        okText={mode === "detail" ? "关闭" : "确定"}
        cancelText="取消"
        onOk={() => {
          console.log("form", form);
          if (mode === "detail") {
            setVisible(false);
            return;
          }
          onAdd();
        }}
        onCancel={() => setVisible(false)}
      >
        <Form
          name="basic"
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          initialValues={{ remember: true }}
          autoComplete="off"
        >
          <Form.Item
            label="标题"
            name="title"
            rules={[{ required: true, message: "请填写标题!" }]}
          >
            <Input placeholder="请填写标题" disabled={mode === "detail"} />
          </Form.Item>

          <Form.Item
            label="所属分类"
            name="classification"
            rules={[{ required: true, message: "请选择所属分类!" }]}
          >
            <Select
              placeholder="请选择所属分类"
              allowClear
              disabled={mode === "detail"}
            >
              <Select.Option value="知识科普">知识科普</Select.Option>
              <Select.Option value="活动邀请">活动邀请</Select.Option>
              <Select.Option value="达人分享">达人分享</Select.Option>
              <Select.Option value="操作指南">操作指南</Select.Option>
              <Select.Option value="问题锦囊">问题锦囊</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="用户分层"
            name="userLevel"
            rules={[{ required: true, message: "请选择用户分层!" }]}
          >
            <Select
              placeholder="请选择用户分层"
              allowClear
              disabled={mode === "detail"}
            >
              <Select.Option value="普通用户">普通用户</Select.Option>
              <Select.Option value="车主用户">车主用户</Select.Option>
              <Select.Option value="官方账号">官方账号</Select.Option>
              <Select.Option value="KOL达人">KOL达人</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="车型解析"
            name="carModel"
            rules={[{ required: true, message: "请选择车型解析!" }]}
          >
            <Select
              placeholder="请选择车型解析"
              allowClear
              disabled={mode === "detail"}
            >
              <Select.Option value="山海系列">山海系列</Select.Option>
              <Select.Option value="大圣系列">大圣系列</Select.Option>
              <Select.Option value="旅行者系列">旅行者系列</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="内容场景"
            name="contentType"
            rules={[{ required: true, message: "请选择内容场景!" }]}
          >
            <Select
              placeholder="请选择内容场景"
              allowClear
              disabled={mode === "detail"}
            >
              <Select.Option value="旅行者分享">旅行者分享</Select.Option>
              <Select.Option value="使用攻略">使用攻略</Select.Option>
              <Select.Option value="活动分享">活动分享</Select.Option>
              <Select.Option value="爱车养车">爱车养车</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="内容"
            name="content"
            rules={[{ required: true, message: "请输入内容!" }]}
          >
            <Input.TextArea rows={4} disabled={mode === "detail"} />
          </Form.Item>

          {/* <Form.Item label="附件" name="file">
            <Upload
              action="/upload.do"
              listType="picture-card"
              disabled={mode === "detail"}
            >
              <button
                style={{
                  color: "inherit",
                  cursor: "inherit",
                  border: 0,
                  background: "none",
                }}
                type="button"
              >
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>选择文件</div>
              </button>
            </Upload>
          </Form.Item> */}

          <Form.Item label="星级设置" name="starLevel" initialValue={3}>
            <Rate disabled={mode === "detail"} />
          </Form.Item>

          <Form.Item label="是否允许下载" name="allowDownload" initialValue={1}>
            <Radio.Group disabled={mode === "detail"}>
              <Radio value={1}>是</Radio>
              <Radio value={0}>否</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="投放渠道"
            name="deliveryChannel"
            initialValue={"公域"}
          >
            <Radio.Group disabled={mode === "detail"}>
              <Radio value="公域">公域</Radio>
              <Radio value="私域">私域</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="流量" name="flow" initialValue={1}>
            <Flex wrap gap="middle" style={{ marginTop: 16 }}>
              <Progress
                type="flow"
                steps={8}
                percent={50}
                trailColor="rgba(0, 0, 0, 0.06)"
                strokeWidth={20}
              />
              <Progress
                type="circle"
                percent={100}
                steps={{ count: 5, gap: 7 }}
                trailColor="rgba(0, 0, 0, 0.06)"
                strokeWidth={20}
              />
            </Flex>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default Center;
